const cardItems = [
  {
    title: '高清画质 · 流畅不卡',
    desc: '全线支持1080P超清画质，智能自适应码率技术确保在任何网络环境下都能流畅播放，告别缓冲等待。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20theater%20setup%20with%20large%204K%20screen%20displaying%20vivid%20cinematic%20scene%2C%20soft%20ambient%20lighting%2C%20clean%20contemporary%20interior%2C%20professional%20product%20photography%20style&width=500&height=350&seq=cards-01&orientation=landscape',
  },
  {
    title: '海量片库 · 每日更新',
    desc: '汇聚超过两万部影视资源，涵盖电影、电视剧、综艺、动漫等全品类，编辑团队每日精选更新最新内容。',
    image: 'https://readdy.ai/api/search-image?query=Vast%20digital%20movie%20library%20with%20colorful%20film%20posters%20arranged%20in%20grid%20on%20dark%20background%2C%20organized%20and%20diverse%20collection%2C%20warm%20glowing%20accents%2C%20professional%20editorial%20photography&width=500&height=350&seq=cards-02&orientation=landscape',
  },
  {
    title: '多端同步 · 随时随地',
    desc: '全面支持PC、平板和手机浏览器访问，无需安装插件即可即点即播，跨设备无缝切换观影进度。',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20devices%20displaying%20same%20movie%20streaming%20interface%20including%20laptop%20tablet%20and%20smartphone%20on%20clean%20desk%2C%20warm%20cozy%20workspace%20lighting%2C%20modern%20tech%20lifestyle%20photography&width=500&height=350&seq=cards-03&orientation=landscape',
  },
  {
    title: '智能推荐 · 发现好片',
    desc: '基于观影偏好与热门趋势的智能内容推荐系统，帮你从海量片库中快速找到最符合口味的好电影。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20movie%20recommendation%20interface%20with%20holographic%20film%20posters%20floating%20in%20dark%20space%2C%20data%20visualization%20elements%2C%20warm%20amber%20accents%2C%20sleek%20modern%20design&width=500&height=350&seq=cards-04&orientation=landscape',
  },
  {
    title: '安全稳定 · 放心观影',
    desc: '平台采用HTTPS加密传输和多重安全防护，杜绝恶意弹窗和广告骚扰，为你提供纯净安心的观影环境。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20secure%20digital%20environment%20concept%20with%20shield%20symbol%20and%20padlock%20over%20glowing%20data%20streams%2C%20dark%20background%20with%20warm%20green%20and%20amber%20highlights%2C%20professional%20cybersecurity%20visual&width=500&height=350&seq=cards-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">服务亮点</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">图文信息 · 平台优势</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">为什么选择91电影视频？五大核心优势让你放心观影</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-sm text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}